import { render, staticRenderFns } from "./AdvantageBloc.vue?vue&type=template&id=3459e15f&scoped=true"
import script from "./AdvantageBloc.vue?vue&type=script&lang=js"
export * from "./AdvantageBloc.vue?vue&type=script&lang=js"
import style0 from "./AdvantageBloc.vue?vue&type=style&index=0&id=3459e15f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3459e15f",
  null
  
)

export default component.exports